
import axios from "axios";
import { CONFIG } from "../../../appconfig/appconfig";
import { getBranchId, getHospitalId, getLoginID, getToken } from "../../../auth";
import FetchData from "../../client";

const getProcurementList = async (inputData) => {
  try {
    inputData.doctorid = getLoginID();
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId()
    const result = await FetchData("midoc_getmedicineinvoice", inputData);
    // console.log(result, 'api DAtaa')
    return result;

  } catch (error) {
    console.error('Error updating profile:', error); 
    throw error;
  }
};
const UploadInvoiceToFetchDetails = async (inputData) => {
  try {
    const token = getToken();
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
    const response = await axios.post(
      // `http://127.0.0.1:8000/doctor-notes-helpers/correct-cc`,
      `${CONFIG.APIBaseUrl}midoc_ai_procurementinvoiceupload`,
      inputData,
      {
        headers: headers,
      }
    );

    return response;
  } catch (error) {
    console.error("Error fetching data in forms.js:", error);
    throw error;
  }
};
const SaveInvoiceData = async (inputData) => {
  try {
    inputData.doctorid = getLoginID();
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId()
    const result = await FetchData("midoc_addmedicineinvoice", inputData);
    // console.log(result, 'api DAtaa')
    return result;

  } catch (error) {
    console.error('Error updating profile:', error); 
    throw error;
  }
};
const getInvoiceDetails = async (inputData) => {
  try {
    inputData.doctorid = getLoginID();
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId()
    const result = await FetchData("midoc_getmedicineinvoicedetails", inputData);
    // console.log(result, 'api DAtaa')
    return result;

  } catch (error) {
    console.error('Error updating profile:', error); 
    throw error;
  }
};
const UpdatePaymentstatus = async (inputData) => {
  try {
    inputData.doctorid = getLoginID();
    inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId()
    const result = await FetchData("midoc_updateinvoicepaymentstatus", inputData);
    // console.log(result, 'api DAtaa')
    return result;

  } catch (error) {
    console.error('Error updating profile:', error); 
    throw error;
  }
};
  export {getProcurementList, UploadInvoiceToFetchDetails, SaveInvoiceData, getInvoiceDetails, UpdatePaymentstatus};

